import _ from "lodash";
import call from "../../../shared/service/http";
import {EventBus} from "../../../shared/utilities/event-bus";
import DashboardConstants from "@/packages/dashboard/DashboardConstants";

export default {
    namespaced: true,
    state: {
        loading: false,
        scopes:[],
        applications:[],
        state: {
            loading: false,
            isWaas:false,
        },
        links: [
            {
                to: "/dashboard/applications",
                order: 1,
                icon: "mdi-apps",
                title: "My Applications",
                disabled: false,
                // sublinks:[
                //     {
                //         to: "/dashboard/my-applications/sandbox",
                //         order: 1,
                //         icon: "mdi-radioactive-off",
                //         title: "Sandbox",
                //         disabled: false,
                //     },
                //     {
                //         to: "/dashboard/my-applications/production",
                //         order: 2,
                //         icon: "mdi-radioactive",
                //         title: "Production",
                //         disabled: false,
                //     },
                // ]
            },
        ],
        actions: [],
        menus: [],
        companies: [],
    },
    mutations: {
        SET_LINKS: (state, payload) => {
            if (_.findIndex(state.links, payload) === -1) {
                state.links.push(payload);
            }
        },
        SET_LOADING: (state, payload) => {
            state.loading = payload;
        },
        SET_WAAS: (state,payload) =>{
            state.isWaas=payload
        },
        MUTATE: (state, payload) => {
            state[payload.state] = payload.data;
        },
    },

    getters: {
        waas: (state) => state.isWaas,
        loading: (state) => state.loading,
        links: (state) => {
            return _.orderBy(state.links, (link) => link.order);
        },
        DashboardGetter: (state) => (setup) => state[setup],
    },

    actions: {
        /**
         *
         * @param commit
         * @param isLive
         */
        getApplications: ({commit},{isLive}) => {
            commit('Dashboard/SET_LOADING',true,{root:true})
            call("get", DashboardConstants.APPLICATIONS)
                .then(res => {
                    commit('Dashboard/SET_LOADING',false,{root:true})
                    if (res.status) {
                        commit("MUTATE",{
                            state:"applications",
                            data: isLive ?
                                res.data['applications']?.filter(el=>el.environment==="PRODUCTION") :
                                res.data['applications']?.filter(el=>el.environment==="SANDBOX")
                        })
                    } else{
                        EventBus.$emit("ApiError",res.data.detail);
                    }
                })
                .catch( (err) => {
                    console.log(err)
                    commit('Dashboard/SET_LOADING',false,{root:true})
                    EventBus.$emit("ApiError",err?.response?.data?.message || 'Something went wrong');
                });
        },
        /**
         *
         * @param commit
         * @param dispatch
         * @param payload
         */
        createApplications: ({commit,dispatch},payload) => {
            commit('Dashboard/SET_LOADING',true,{root:true})
            call("post", DashboardConstants.APPLICATIONS,payload)
                .then(res => {
                    commit('Dashboard/SET_LOADING',false,{root:true})
                    if (res.data.status) {
                        EventBus.$emit("goLive",true)
                        EventBus.$emit("ApiSuccess", res?.data?.detail || res?.data?.message);
                        //
                        setTimeout(()=>{
                            dispatch("getApplications")
                        },1500)
                    } else{
                        EventBus.$emit("ApiError",res.data.detail || res?.data?.message);
                    }
                })
                .catch( (err) => {
                    commit('Dashboard/SET_LOADING',false,{root:true})
                    EventBus.$emit("ApiError",err?.response?.data?.message || 'Something went wrong');
                });
        },
        /**
         *
         * @param commit
         * @param dispatch
         * @param payload
         */
        confirmApplication: ({commit,dispatch},payload) => {
            commit('Dashboard/SET_LOADING',true,{root:true})
            call("post", DashboardConstants.CONFIRM_APPLICATION,payload)
                .then(res => {
                    commit('Dashboard/SET_LOADING',false,{root:true})
                    if (res.data.status) {
                        EventBus.$emit("goLive",false)
                        EventBus.$emit("ApiSuccess", res?.data?.detail || res?.data?.message);
                        //
                        setTimeout(()=>{
                            dispatch("getApplications")
                        },1500)
                    } else{
                        EventBus.$emit("ApiError",res.data.detail || res?.data?.message);
                    }
                })
                .catch( (err) => {
                    commit('Dashboard/SET_LOADING',false,{root:true})
                    EventBus.$emit("ApiError",err?.response?.data?.message || 'Something went wrong');
                });
        },
        /**
         *
         * @param commit
         */
        getScopes: ({commit}) => {
            commit('Dashboard/SET_LOADING',true,{root:true})
            call("get", DashboardConstants.APPLICATION_SCOPES)
                .then(res => {
                    commit('Dashboard/SET_LOADING',false,{root:true})
                    if (res.data.status) {
                        commit("MUTATE",{
                            state:"scopes",
                            data:res.data.scopes
                        })
                    } else{
                        EventBus.$emit("ApiError",res.data?.detail||res.data?.message);
                    }
                })
                .catch( (err) => {
                    commit('Dashboard/SET_LOADING',false,{root:true})
                    EventBus.$emit("ApiError",err?.response?.data?.message || 'Something went wrong');
                });
        },
    },
};
